import {useMemo} from 'react'
import _ from 'lodash'
import {GridChildComponentProps} from 'react-window'
import {useParsedFields} from '@/utils/media'
import {IDataSourceItem} from '@/features/data-sources'
import {IGridState} from '.'

// type GridItemType<T extends IDataSourceItem> = GridChildComponentProps<IGridState<T>> & React.HTMLAttributes<HTMLDivElement>;

export interface IMediaListItemProps<T extends IDataSourceItem>
  extends GridChildComponentProps<IGridState<T>> {
  className?: string
  overlay?: React.ReactNode
  viewMode?: 'grid' | 'list' | 'single-row'
  parentTitle?: string
  title?: string
}

export function MediaListItem<T extends IDataSourceItem>(props: IMediaListItemProps<T>) {
  const {data, style, columnIndex, rowIndex, viewMode: propsViewMode} = props

  const {columnCount, rowCount, items, itemProps, viewMode} = data

  const _viewMode = propsViewMode || viewMode || 'grid'

  const index = rowIndex * columnCount + columnIndex
  const {_id, title, poster} = useParsedFields(items[index]) || {}

  const {
    overlay,
    className,
    style: itemStyle,
    parentTitle,
    title: itemTitle,
    ...rest
  } = useMemo<Partial<IMediaListItemProps<T>>>(() => {
    return _.isFunction(itemProps) ? itemProps(items[index], index) : itemProps || {}
  }, [itemProps, items[index]])

  const extraTitle = useMemo(() => {
    if (!parentTitle || parentTitle === title) return
    if (viewMode !== 'list')
      return (
        <>
          {parentTitle}
          <br />
        </>
      )
    return `${parentTitle}: `
  }, [parentTitle, title, viewMode])

  if (!_id) return

  const classNames = _.chain([
    'item',
    className,
    _viewMode,
    viewMode === 'list' && rowIndex % 2 === 0 ? 'even' : undefined,
    rowIndex === 0 ? 'top-edge' : undefined,
    rowCount > 1 && rowIndex === rowCount - 1 ? 'bottom-edge' : undefined,
    columnCount > 1 && columnIndex === 0 ? 'left-edge' : undefined,
    columnCount > 1 && columnIndex === columnCount - 1 ? 'right-edge' : undefined,
  ])
    .compact()
    .join(' ')
    .value()

  return (
    <div
      {...rest}
      className={classNames}
      style={{
        ...style,
        ...itemStyle,
      }}
    >
      <div className='content'>
        {extraTitle}
        {itemTitle || title || _id}
      </div>
      {viewMode !== 'list' && poster ?
        <div
          className='background'
          style={{
            backgroundImage: poster ? `url(${poster})` : undefined,
          }}
        />
      : undefined}
      {overlay ?
        <div className='overlay'>{overlay}</div>
      : null}
    </div>
  )
}
